import { apiFetch } from './api';

export const calendarApi = {
    // Events
    getEvents: async () => {
        const response = await apiFetch('/calendar/events');
        if (!response.ok) throw new Error('Failed to fetch events');
        return response.json();
    },
    createEvent: async (eventData) => {
        const response = await apiFetch('/calendar/events', {
            method: 'POST',
            body: JSON.stringify(eventData)
        });
        if (!response.ok) throw new Error('Failed to create event');
        return response.json();
    },
    updateEvent: async (id, eventData) => {
        const response = await apiFetch(`/calendar/events/${id}`, {
            method: 'PUT',
            body: JSON.stringify(eventData)
        });
        if (!response.ok) throw new Error('Failed to update event');
        return response.json();
    },
    deleteEvent: async (id) => {
        const response = await apiFetch(`/calendar/events/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) throw new Error('Failed to delete event');
        return true;
    },

    // Todos
    getTodos: async () => {
        const response = await apiFetch('/calendar/todos');
        if (!response.ok) throw new Error('Failed to fetch todos');
        return response.json();
    },
    createTodo: async (todoData) => {
        const response = await apiFetch('/calendar/todos', {
            method: 'POST',
            body: JSON.stringify(todoData)
        });
        if (!response.ok) throw new Error('Failed to create todo');
        return response.json();
    },
    updateTodo: async (id, todoData) => {
        const response = await apiFetch(`/calendar/todos/${id}`, {
            method: 'PUT',
            body: JSON.stringify(todoData)
        });
        if (!response.ok) throw new Error('Failed to update todo');
        return response.json();
    },
    deleteTodo: async (id) => {
        const response = await apiFetch(`/calendar/todos/${id}`, {
            method: 'DELETE'
        });
        if (!response.ok) throw new Error('Failed to delete todo');
        return true;
    }
};
